require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./umatilla-county-domestic-violence-supervision.json") })
        }
      }, "path---umatilla-county-domestic-violence-supervision");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---umatilla-county-domestic-violence-supervision!./.cache/json/umatilla-county-domestic-violence-supervision.json
// module id = 1061
// module chunks = 231608221292675